import React from 'react'

const DisplayOptionContext = React.createContext(`CROPPED`);

export default DisplayOptionContext;